import Vue from 'vue'
import VueRouter from 'vue-router'

import AuthentificationService from '@/services/authentification'
import BusinessService from '@/services/business'
import BreadcrumbsService from '@/services/breadcrumbs'
import { waitForSignal } from '@/services/signals'
import { URL_ACCOUNT_LOGIN, URL_ACCOUNT_BUSINESS_SELECT, URL_ROOT } from '@/consts/urls'

import routes from './routes'

Vue.use(VueRouter)

async function scrollBehavior(to, from, savedPosition) {
  if (to.meta.waitForScrollSignal) {
    await waitForSignal('scroll')
  }

  if (savedPosition) {
    return savedPosition
  }

  if (to.hash) {
    return { selector: to.hash, offset: to.meta.scrollOffset }
  }

  return { x: 0, y: 0 }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(r => !r.meta.anonymous)) {
    const isLoggedIn = AuthentificationService.getUserIsLogged()

    if (!isLoggedIn) {
      return next({
        name: URL_ACCOUNT_LOGIN,
        query: {
          returnPath: to.fullPath
        }
      })
    }
  }

  if (to.matched.some(r => r.meta.business)) {
    const business = await BusinessService.getCurrentBusiness()
    if (!business || !business.id) {
      return next({
        name: URL_ACCOUNT_BUSINESS_SELECT,
        query: {
          returnPath: to.fullPath
        }
      })
    }
  }

  const currentUserType = AuthentificationService.getUserType()
  for (const match of to.matched) {
    if (match.meta.usertype && currentUserType !== match.meta.usertype) {
      return next({
        name: URL_ROOT
      })
    }
  }

  next()
})

router.afterEach((to, from) => {
  if (to.path != from.path) {
    BreadcrumbsService.clear()
  }
})

export default router
